import React from 'react';
import {MarketStatusTraderUpdatesPanel} from '../components/panels/marketStatusTraderUpdates.panel';

export const HomePage = React.memo(() => (
    <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'>
        <MarketStatusTraderUpdatesPanel type='marketStatus' />
        <MarketStatusTraderUpdatesPanel type='traderUpdates' />
    </div>
));
